import { Link } from 'react-router-dom';
import { siteInfo } from '@/lib/site';

const highlights = [
  {
    icon: 'ri-live-line',
    title: '实时直播状态',
    desc: '每场赛事标注直播中、即将开始与已结束，一眼看清能否马上观看。',
  },
  {
    icon: 'ri-filter-3-line',
    title: '精准筛选检索',
    desc: '按联赛、直播状态与时间筛选，也可用球队或赛事名称直接搜索。',
  },
  {
    icon: 'ri-line-chart-line',
    title: '赛况数据演示',
    desc: '详情页提供比分、分节得分与命中率对比，帮助快速了解比赛走势。',
  },
];

export default function AboutIntro() {
  return (
    <section aria-labelledby="about-intro" className="w-full rounded-lg bg-primary-950 overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-0">
        <div className="lg:col-span-5 px-5 py-8 md:px-8 md:py-10 flex flex-col justify-between hero-grain">
          <div>
            <p className="font-heading text-[11px] tracking-[0.28em] text-accent-400 mb-3">ABOUT US</p>
            <h2 id="about-intro" className="font-heading text-2xl md:text-3xl leading-tight text-background-50">
              关于<span className="text-accent-400"> {siteInfo.name}</span>
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-300">
              我们专注于篮球赛事的直播信息聚合，覆盖 NBA、CBA 与 FIBA 国际赛事。用统一的时间线与状态标签，让你最快找到今晚值得看的那一场。
            </p>
          </div>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 rounded-md bg-accent-500 px-4 py-2.5 text-sm font-medium text-background-50 hover:bg-accent-600 transition-colors whitespace-nowrap"
            >
              了解网站定位
              <i className="ri-arrow-right-line" />
            </Link>
            <a
              href={`mailto:${siteInfo.email}`}
              className="inline-flex items-center gap-2 rounded-md border border-background-50/25 px-4 py-2.5 text-sm text-background-100 hover:border-accent-400 hover:text-accent-300 transition-colors whitespace-nowrap"
            >
              <i className="ri-mail-line" />
              {siteInfo.email}
            </a>
          </div>
        </div>

        <div className="lg:col-span-7 bg-primary-900 px-5 py-8 md:px-8 md:py-10 flex flex-col justify-between">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {highlights.map((item) => (
              <div key={item.title} className="flex flex-col">
                <span className="w-10 h-10 rounded-md bg-background-50/10 text-accent-400 flex items-center justify-center text-xl mb-3">
                  <i className={item.icon} />
                </span>
                <h3 className="font-heading text-sm text-background-50 mb-1.5">{item.title}</h3>
                <p className="text-xs leading-relaxed text-background-300">{item.desc}</p>
              </div>
            ))}
          </div>
          <div className="mt-6 pt-5 border-t border-primary-800 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
            <p className="max-w-md text-[11px] leading-relaxed text-background-400">
              说明：本站直播画面与赛况数据均为前端演示内容，尚未接入真实流媒体服务与官方数据源，请以实际赛事转播为准。
            </p>
            <Link
              to="/search"
              className="inline-flex items-center gap-1.5 text-[11px] text-background-300 hover:text-accent-300 transition-colors whitespace-nowrap"
            >
              <i className="ri-search-line" />
              搜索一支球队
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}